export default __webpack_public_path__ + "static/dexga-d4770a859d76ad69013cf39bc551ef63.png";